import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';

export interface PackageRowActionItem {
  id: string;
  label: string;
  icon: string;
  iconSize?: number;
  danger?: boolean;
  borderTop?: boolean;
  borderBoth?: boolean;
}

@Component({
  selector: 'app-package-row-actions',
  standalone: true,
  imports: [MatMenuModule],
  templateUrl: './package-row-actions.component.html',
  styleUrl: './package-row-actions.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PackageRowActionsComponent {
  @Input({ required: true }) items: PackageRowActionItem[] = [];
  @Input() ariaLabel = 'Open actions menu';
  /**
   * `data-testid` stem: emits `<testId>-trigger` for the kebab button and
   * `<testId>-item-<actionId>` for each menu entry, so the hooks follow the action's own id
   * rather than its position in the menu.
   */
  @Input() testId = 'row-actions';
  @Output() readonly menuOpened = new EventEmitter<void>();
  @Output() readonly action = new EventEmitter<string>();

  onSelect(id: string): void {
    this.action.emit(id);
  }
}
